module.exports = __webpack_public_path__ + "static/media/bubble-3.2051578e.png";